import { Toast } from "primereact/toast";
import React, { useRef, useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import profileImage from "../../assets/images/mahesh.png";
import { getCookie } from "../../helpers/cookie";
import { useForm } from "react-hook-form";

const MyAccount = () => {
  const toast = useRef(null);

  const [showPhotoDialog, setShowPhotoDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);

  const UserInfo = JSON.parse(getCookie("user_info") || "{}");
console.log(UserInfo,'Userinfo');

  const {
    register,
    setValue,
    formState: { errors },
  } = useForm();

  const [profileData, setProfileData] = useState({
    profilePicture: profileImage,
  });

  /* -------------------- SET INITIAL VALUES FROM USERINFO -------------------- */
  useEffect(() => {
    if (UserInfo) {
      setValue("name", UserInfo?.profile?.fullname || "");
      setValue("email", UserInfo?.profile?.email || "");
      setValue("mobile", UserInfo?.profile?.mobile || "");
      setValue("username", UserInfo?.username || "");
      setValue("role", UserInfo?.role_name || "");
      setValue("developer", UserInfo?.role || "");

      setProfileData((prev) => ({
        ...prev,
        profilePicture: UserInfo.profilePicture || profileImage,
      }));
    }
  }, [UserInfo, setValue]);

  /* -------------------- IMAGE UPLOAD -------------------- */
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileData((prev) => ({
        ...prev,
        profilePicture: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const PhotoDialog = () => (
    <div className={`photo-dialog ${showPhotoDialog ? "" : "hidden"}`}>
      <div className="dialog-content">
        <div className="dialog-header">
          <h3>Update Profile Photo</h3>
          <button onClick={() => setShowPhotoDialog(false)} className="close-btn">
            ✕
          </button>
        </div>

        <div className="preview-image-container">
          <img
            src={profileData.profilePicture}
            alt="Preview"
            className="preview-image"
          />
        </div>

        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          disabled={!isEditMode}
        />
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <Container fluid>
        <Toast ref={toast} />
<div className="admin-dash lookup">
        <Row>
          <Col lg={12} className="d-flex justify-content-between align-items-center mt-3">
            <h1 className="page-title ms-3" style={{ fontSize: "1.5rem", color: "#126fa9" }}>
              My Account
            </h1>

            {/* EDIT BUTTON */}
            <button
              className="btn btn-outline-primary me-3"
              onClick={() => setIsEditMode(!isEditMode)}
            >
              <i className="pi pi-pencil me-1"></i>
              {isEditMode ? "Cancel" : "Edit"}
            </button>
          </Col>
        </Row>

        <div className="profile-preview-container mt-4">
          <PhotoDialog />

          {/* HEADER */}
          <div className="profile-header">
            <div className="profile-header-content">
              <div className="profile-image-container">
                <img
                  src={profileData.profilePicture}
                  alt="Profile"
                  className="profile-image"
                />
                {isEditMode && (
                  <button
                    onClick={() => setShowPhotoDialog(true)}
                    className="change-photo-btn"
                  >
                    <i className="pi pi-pencil"></i>
                  </button>
                )}
              </div>
              <div>
                <h1 className="profile-name">{UserInfo?.name}</h1>
                <p className="profile-role">{UserInfo?.role}</p>
              </div>
            </div>
          </div>

          {/* TABS */}
          <div className="tabs">
            <button
              className={`tab-btn ${activeTab === 0 ? "active-tab" : ""}`}
              onClick={() => setActiveTab(0)}
            >
              Profile Information
            </button>
          </div>

          {/* FORM */}
          <div className="profile-content">
            <div className="profile-grid">
              <div className="left-column">
                <label className="mt-3">Name</label>
                <input
                  {...register("name")}
                  disabled={!isEditMode}
                  className="profile-input"
                />

                <label className="mt-3">Email</label>
                <input
                  {...register("email")}
                  disabled
                  className="profile-input"
                />

                <label className="mt-3">Mobile Number</label>
                <input
                  {...register("mobile")}
                  disabled={!isEditMode}
                  className="profile-input"
                />
              </div>

              <div className="right-column">
                <label className="mt-3">Username</label>
                <input
                  {...register("username")}
                  disabled
                  className="profile-input"
                />

                <label className="mt-3">Roles and Permission</label>
                <input
                  {...register("role")}
                  disabled
                  className="profile-input"
                />
              </div>
            </div>
          </div>
        </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default MyAccount;
